<div class="align-right">
  <button mat-button color="primary" (click)="addQuestion()">
    <mat-icon>add_circle_outline</mat-icon>
    <span> add </span>
  </button>
</div>
<div class="table-container">
  <table mat-table [dataSource]="questions" matSort>

    <ng-container matColumnDef="shortCode">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"intelligence-reporting.questions.short-code" |translate}}</th>
      <td mat-cell *matCellDef="let question">{{question.shortCode}}</td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"admin.dialogs.description" |translate}}</th>
      <td mat-cell *matCellDef="let question">{{question.description}}</td>
    </ng-container>

    <ng-container matColumnDef="category.description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"admin.templates.category" |translate}}</th>
      <td mat-cell *matCellDef="let question">{{question.category.description}}</td>
    </ng-container>

    <ng-container matColumnDef="questionType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"intelligence-reporting.questions.question-type" |translate}}</th>
      <td mat-cell *matCellDef="let question">{{question.questionType}}</td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let question">
        <mat-icon (click)="editQuestion(question)" color="primary"
                  matTooltip="Edit" matTooltipPosition="above">edit
        </mat-icon>
        <mat-icon *ngIf="question.status === 'ACTIVE'" color="primary"
                  matTooltip="Disable" matTooltipPosition="above"
                  (click)="updateQuestion(question)">check_circle
        </mat-icon>
        <mat-icon *ngIf="question.status === 'INACTIVE'"
                  color="primary" matTooltip="Enable" matTooltipPosition="above"
                  (click)="updateQuestion(question)">radio_button_unchecked
        </mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator color="primary" [length]="totalElements"
                 [pageSize]="pageSize"
                 (page)="onPageChange($event)"
                 [pageSizeOptions]="pageSizes">
  </mat-paginator>
</div>
